import { ReminderModal } from '@ReactComponents/TransactionsPage/TransactionsModals/ReminderModal';

import { AppThunkDispatch } from '@Reducers/index';

import { IUnapproveExpenseData, TransactionsApi } from '@ClientApi/transactionsApi';
import { IExpenseModel } from '@Shared/models';

import { ShowModal } from './modalActions';

export const SELECT_REIMBURSABLE_EXPENSE = 'SELECT_REIMBURSABLE_EXPENSE';
export const RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP = 'RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP';
export const RESET_REIMBURSABLE_EXPENSES = 'RESET_REIMBURSABLE_EXPENSES';
export const CLEAR_REIMBURSABLE_EXPENSE = 'CLEAR_REIMBURSABLE_EXPENSE';

export class ResetReimbursableExpensesLoadedTimestamp {
  readonly type = RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP;
}

export class ResetReimbursableExpenses {
  readonly type = RESET_REIMBURSABLE_EXPENSES;
}

export class SelectReimbursableExpense {
  readonly type = SELECT_REIMBURSABLE_EXPENSE;

  constructor(public payload: IExpenseModel | null) {}
}

export class ClearReimbursableExpense {
  readonly type = CLEAR_REIMBURSABLE_EXPENSE;
}

export const approveReimbursableExpense = (expense: IExpenseModel) => async (dispatch: AppThunkDispatch) => {
  await TransactionsApi.approve(expense.id);
};

export const denyReimbursableExpense =
  (expense: IExpenseModel, data: Parameters<typeof TransactionsApi.deny>[1]) => async (dispatch: AppThunkDispatch) => {
    await TransactionsApi.deny(expense.id, data);
  };

export const unapproveReimbursableExpense = (expense: IExpenseModel, data: IUnapproveExpenseData) => async (dispatch: AppThunkDispatch) => {
  await TransactionsApi.unapprove(expense.id, data);
};

export const deleteReimbursableExpense = (expense: IExpenseModel) => async (dispatch: AppThunkDispatch) => {
  await TransactionsApi.deleteOne(expense.id);
};

export const openReminderModal = (userId: string) => {
  return new ShowModal(ReminderModal, {
    onSuccessfulReminder: () => {},
    userId
  });
};

export const clearReimbursableExpense = () => (dispatch: AppThunkDispatch) => {
  dispatch(new ClearReimbursableExpense());
};

export type ReimbursableExpensesActions =
  | ResetReimbursableExpensesLoadedTimestamp
  | ResetReimbursableExpenses
  | SelectReimbursableExpense
  | ClearReimbursableExpense;
